import { z } from 'zod';

const DataSchema = z.union([z.record(z.unknown()), z.array(z.unknown()), z.string(), z.number(), z.boolean()]);

export const ChangeSchema = z.object({
    type: z.enum(['set', 'create', 'update', 'delete']),
    data: DataSchema,
    previousData: DataSchema.optional(),
});
